import { render, staticRenderFns } from "./Login-callback.vue?vue&type=template&id=0c63f850"
import script from "./Login-callback.vue?vue&type=script&lang=js"
export * from "./Login-callback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports